// extracted by mini-css-extract-plugin
export default {"resultat_recherche":"resultat-recherche_resultat_recherche__SEbgq","bouton_resultat_recherche":"resultat-recherche_bouton_resultat_recherche__mCTnH"};